export default class ResolverNames {
    static get delegate() {
        return 'delegate';
    }
    static get factory() {
        return 'factory';
    }
    static get externalFactory() {
        return 'externalFactory';
    }
    static get literal() {
        return 'literal';
    }
}